// all action types here

// to fettch incidents from server
export const FETCH_INCIDENTS = 'FETCH_INCIDENTS';
export const FETCH_INCIDENTS_START = 'FETCH_INCIDENTS_START';
export const FETCH_INCIDENTS_SUCCESS = 'FETCH_INCIDENTS_SUCCESS';
export const FETCH_INCIDENTS_FAIL = 'FETCH_INCIDENTS_FAIL';

// for incident details
export const FETCH_INCIDENT_DETAIL = 'FETCH_INCIDENT_DETAIL';
export const FETCH_INCIDENT_DETAIL_START = 'FETCH_INCIDENT_DETAIL_START';
export const FETCH_INCIDENT_DETAIL_SUCCESS = 'FETCH_INCIDENT_DETAIL_SUCCESS';
export const FETCH_INCIDENT_DETAIL_FAIL = 'FETCH_INCIDENT_DETAIL_FAIL';

// filter incidents
export const FILTER_INCIDENTS = 'FILTER_INCIDENTS';